import { useRef, useState } from 'react'
import RangeCalendar from '@/components/ui/RangeCalendar'
import { formatShippingPeriod } from '@/utils/shippingPeriod'

interface ShippingPeriodInputProps {
  startDate: Date | null
  endDate: Date | null
  onChange: (startDate: Date | null, endDate: Date | null) => void
}

const ShippingPeriodInput = ({ startDate, endDate, onChange }: ShippingPeriodInputProps) => {
  const [showCalendar, setShowCalendar] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const displayValue =
    startDate || endDate
      ? formatShippingPeriod(startDate, endDate)
      : ''

  const handleDateSelect = (start: Date | null, end: Date | null) => {
    onChange(start, end)
    if (start && end) {
      setShowCalendar(false)
    }
  }

  return (
    <div className="relative" style={{ position: 'relative', zIndex: showCalendar ? 100 : 1 }}>
      <input
        ref={inputRef}
        type="text"
        value={displayValue}
        onFocus={() => setShowCalendar(true)}
        readOnly
        placeholder="Select start and end date"
        className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 cursor-pointer"
        style={{
          fontFamily: 'Lexend Deca',
          fontSize: '12px',
          height: '40px',
          border: '1px solid #E9E9EA',
          borderRadius: '8px',
        }}
      />
      <img
        src="/images/calendar.svg"
        alt="Calendar"
        onClick={() => setShowCalendar(true)}
        role="button"
        className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
        style={{ width: '18px', height: '18px', opacity: 0.6 }}
      />
      {showCalendar && (
        <RangeCalendar
          isOpen={showCalendar}
          onClose={() => setShowCalendar(false)}
          onDateSelect={handleDateSelect}
          selectedStartDate={startDate}
          selectedEndDate={endDate}
        />
      )}
    </div>
  )
}

export default ShippingPeriodInput
